export default __webpack_public_path__ + "static/dd-trades-615432bfd9c39eced1dbc01ce99e1390.jpg";